import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const LoadingFetchingBody = () => {
  return (
    <>
      <Box
        paddingY="s32"
        gap="s16"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        alignItems="center"
      >
        <Spinner />
        <Box>
          <Text size="300">
            {i18n.t('split_documents.bulk_modal.fetching_scores.spinner_title')}
          </Text>
        </Box>
      </Box>
    </>
  )
}

export default LoadingFetchingBody
